import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/account/${number | ':accountId'}/entries`;

export const ROUTE: RouteDefinition = `${baseRoute}/account/:accountId/entries`;

export const URL = (accountId: number): RouteDefinition =>
	`${baseRoute}/account/${accountId}/entries`;
